import PropTypes from 'prop-types';
import { memo, useRef } from 'react';

import Sidebar from 'components/Sidebar';
import TopContributorsCommentsRanking from 'components/TopContributorsCommentsRanking';

import SidebarUserFollows from './SidebarUserFollowsList';

const UserProfileSidebar = ({ gaEventCategory, userId }) => {
  const topContributorsCommentsRankingRef = useRef(null);

  return (
    <Sidebar
      className="col-span-4 xl:col-span-3"
      refsToBeIgnoredBeforeFixing={[topContributorsCommentsRankingRef]}
    >
      <TopContributorsCommentsRanking
        ref={topContributorsCommentsRankingRef}
        className="w-full"
        commentsSourceName="any"
        gaEventCategory={gaEventCategory}
      />
      <SidebarUserFollows gaEventCategory={gaEventCategory} userId={userId} />
    </Sidebar>
  );
};

UserProfileSidebar.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
};

export default memo(UserProfileSidebar);
